import React, { useEffect, useState } from 'react';
import { getTicketDetailAPI } from '@/service/ticketService';
import { API } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { MenuItem } from '@material-ui/core';
import OverFlowTooltipWithTabsMui from '../../common/OverFlowTooltipWithTabsMui';
import { Skeleton } from '@material-ui/lab';
import { tr } from '@/common/utils/tr';

/**
 * `children` is required whenever `isTagMaster` is falsy - it is rendered as-is
 * (already translated by the caller) instead of `itemLabel`. Only skipped for
 * `isTagMaster` items, which fetch/display their own label internally.
 */
export default function RenderTagItemSingleChoice({ item, className, name, id, isTagMaster, onClick, children }) {
    const [itemLabel , setItemLabel] = useState(name);
    const [loading , setLoading] = useState(false);
    
    useEffect(() => {
        if (!isTagMaster) return;
        if(!itemLabel) {
            setLoading(true);
            getTicketDetailAPI(API, id).then((ticketDetailResult) => {
                let detailTicket = ticketDetailResult.detailTicket;
                let titketTitle =  Utils.getTitle(detailTicket?.settingTitle);
                setLoading(false);
                setItemLabel(tr(titketTitle));
            })
        }
    }, [item]);

    return (
        <MenuItem
            key={id}
            value={id}
            onClick={e => onClick(item)}
            className={className}
        >
            {isTagMaster
                ? <OverFlowTooltipWithTabsMui value={loading ? <Skeleton variant="text" width={200} height={30} /> : itemLabel}/>
                : children}
        </MenuItem>
    );
}